<template>
    <div class="mobile-menu">
        <div class="mobile-menu__burger" @click="showMenu = !showMenu">
            <div class="mobile-menu-switch">
                <span class="line"></span>
                <span class="line"></span>
                <span class="line"></span>
            </div>
        </div>

        <div class="mobile-menu__collapse" v-show="showMenu">
            <ul class="mobile-list">
                <li :key="item.id" v-for="item in list">
                    <div class="dropdown-link" v-if="item.routerLink" @click="subMen(item.id)">
                        <router-link tag="a" :to="item.routerLink">{{ item.name }}
                        </router-link>
                    </div>
                    <div class="dropdown-link" v-else @click="subMen(item.id)"><a :href="item.href"
                                                                                  :id="item.tagId">{{ item.name }}</a>
                    </div>
                    <div @click="subMen(item.id)" v-if="item.subList.length"
                         :class="showSubMenu === item.id ? 'minus' : ''" class="template-arrow-menu">
                        <img src="../assets/images/Icon ionic-ios-arrow-down@2x.png" alt="arrow">
                    </div>
                    <ul v-if="item.subList.length && showSubMenu === item.id" class="dropdown-content">
                        <li v-for="sub in item.subList">
                            <router-link v-if="sub.routerLink" tag="a" :to="sub.routerLink">{{ sub.name }}
                            </router-link>
                            <a v-else :href="sub.href" :id="sub.tagId">{{ sub.name }}</a>
                            <ul v-if="sub.subList" class="dropdown-content-sub">
                                <li v-for="sub_sub in sub.subList">
                                    <router-link v-if="sub_sub.routerLink" tag="a" :to="sub_sub.routerLink"
                                    >{{ sub_sub.name }}
                                    </router-link>
                                    <a v-else :href="sub_sub.href">{{ sub_sub.name }}</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "mobile-menu",
    data() {
        return {
            showMenu: false,
            showSubMenu: false,
            a: '',
            list: [
                {
                    id: 1,
                    name: "Поликлиника",
                    routerLink: {name: 'Home'},
                    subList: [
                        {
                            id: 2,
                            name: "О поликлинике",
                            routerLink: {name: 'О поликлинике'},
                        },
                        {
                            id: 3,
                            name: "История поликлиники",
                            routerLink: {name: 'История поликлиники'},
                        },
                        {
                            id: 4,
                            name: "Руководство поликлиники",
                            routerLink: {name: 'Руководство поликлиники'},
                        },
                        {
                            id: 5,
                            name: "Регистрационные документы поликлиники",
                            routerLink: {name: 'Регистрационные документы поликлиники'},
                        },
                        {
                            id: 6,
                            name: "Документы",
                            routerLink: {name: 'Документы'},
                        },
                        {
                            id: 7,
                            name: "Противодействие коррупции",
                            routerLink: {name: 'Противодействие коррупции'},
                        },
                        {
                            id: 8,
                            name: "Вакансии",
                            routerLink: {name: 'Вакансии'},
                        },
                    ]
                },
                {
                    id: 9,
                    name: "Услуги",
                    routerLink: {name: 'Услуги'},
                    subList: []
                },
                {
                    id: 10,
                    name: "Наши Врачи",
                    routerLink: {name: 'Наши Врачи'},
                    subList: [
                        {
                            id: 11,
                            name: "Научные работы наших врачей",
                            routerLink: {name: 'Научные работы наших врачей'},
                        },
                    ]
                },
                {
                    id: 12,
                    name: "Прейскурант",
                    routerLink: {name: 'Прейскурант'},
                    subList: []
                },
                {
                    id: 13,
                    name: "Расписание",
                    routerLink: {name: 'Расписание'},
                    subList: []
                },
                {
                    id: 14,
                    name: "Акции",
                    routerLink: {name: 'Акции'},
                    subList: []
                },
                {
                    id: 15,
                    name: "Пациентам",
                    href: '#',
                    subList: [
                        {
                            id: 16,
                            name: 'Программы',
                            href: '#',
                            subList: [
                                {
                                    id: 17,
                                    name: 'Программы годового обслуживания',
                                    routerLink: {name: 'Программы годового обслуживания'},
                                },
                                {
                                    id: 36,
                                    name: 'Постковидные программы',
                                    routerLink: {name: 'Постковидные программы'},
                                },
                                {
                                    id: 18,
                                    name: 'Ведение беременности',
                                    routerLink: {name: 'Ведение беременности'},
                                },
                                {
                                    id: 19,
                                    name: 'Специальные программы',
                                    routerLink: {name: 'Специальные программы'},
                                },
                            ]
                        },
                        {
                            id: 20,
                            name: 'Информация для пациентов',
                            routerLink: {name: 'Информация для пациентов'},
                        },
                        {
                            id: 21,
                            name: 'Подготовка к исследованиям',
                            routerLink: {name: 'Подготовка к исследованиям'},
                        },
                        {
                            id: 22,
                            name: 'Правила и сроки госпитализации',
                            routerLink: {name: 'Правила и сроки госпитализации'},
                        },
                        {
                            id: 23,
                            name: 'Оформление справок',
                            routerLink: {name: 'Оформление справок'},
                        },
                        {
                            id: 24,
                            name: 'Высокотехнологичная медицинская помощь',
                            routerLink: {name: 'Высокотехнологичная медицинская помощь'},
                        },
                        {
                            id: 25,
                            name: 'Сотрудничество со страховыми компаниями',
                            routerLink: {name: 'Сотрудничество со страховыми компаниями'},
                        },
                        {
                            id: 26,
                            name: 'Страничка психотерапевта',
                            routerLink: {name: 'Страничка психотерапевта'},
                        },
                        {
                            id: 27,
                            name: 'Страничка офтальмолога',
                            routerLink: {name: 'Страничка офтальмолога'},
                        },
                    ]
                },
                {
                    id: 28,
                    name: "Партнерам",
                    href: '#',
                    subList: [
                        {
                            id: 29,
                            name: "Программы медицинского обслуживания",
                            routerLink: {name: 'Программы медицинского обслуживания'},
                        },
                        {
                            id: 30,
                            name: "Медицинские осмотры по приказу 29н",
                            routerLink: {name: 'Медицинские осмотры по приказу 29н'},
                        },
                        {
                            id: 31,
                            name: "Стерилизация медицинских изделий",
                            routerLink: {name: 'Стерилизация медицинских изделий'},
                        },
                    ]
                },
                {
                    id: 32,
                    name: "Новости",
                    routerLink: {name: 'Новости'},
                    subList: []
                },
                {
                    id: 33,
                    name: "Контакты",
                    routerLink: {name: 'Контакты'},
                    subList: []
                },
                {
                    id: 34,
                    name: "a A",
                    href: '#',
                    subList: [
                        {
                            id: 35,
                            // tagId: 'specialButton',
                            name: "Версия для слабовидящих",
                            href: '#',
                        }
                    ]
                },
            ],
        }
    },
    methods: {
        subMen(val) {
            if (val === this.showSubMenu) {
                this.showSubMenu = null;
            } else this.showSubMenu = val;
        }
    },
    watch: {
        $route() {
            if (this.showMenu) {
                this.showMenu = false
            }
            if (this.showSubMenu) {
                this.showSubMenu = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.mobile-menu {
    display: block;
    margin: 0 auto;
    padding: 20px 0 30px;

    &__burger {

        .mobile-menu-switch {
            width: 65px;
            padding: 18px 9px 11px;
            margin: 20px auto;
            background: #fff;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            border: 2px solid #42B3E5;
            cursor: pointer;

            &:hover {
                background: #00b6cc;
                border-color: #00b6cc;

                .line {
                    background-color: #FFF;
                }
            }

            .line {
                display: block;
                width: 32px;
                height: 3px;
                margin-bottom: 6px;
                background-color: #00b6cc;

            }

        }
    }

    &__collapse {
        width: 60%;
        margin: 0 auto;

        .menu-item-has-children {
            position: relative;
        }

        .mobile-list {
        }

        .mobile-list li {
            transition: .5s ease;
            position: relative;
        }

        .mobile-list li .dropdown-link {
            background: #F0F0F0;
        }

        .mobile-list li a {

            &.active {
                background-color: #00b6cc;
                color: #fff;
            }

            display: block;
            color: #000;
            background: #F0F0F0;
            font-size: 14px;
            font-family: arial, sans-serif;
            padding: 12px 20px;
            margin-bottom: 1px;
            line-height: 1;
            border-bottom: 0;
            text-align: left;
        }

        .mobile-list li .dropdown-link a {
            position: relative;
            z-index: 1;
            width: fit-content;
        }


        .mobile_menu_container nav.mobile_menu > ul li a {
            display: block;
            color: #000;
            background: #F0F0F0;
            font-size: 14px;
            font-family: arial, sans-serif;
            padding: 12px 20px;
            margin-bottom: 1px;
            line-height: 1;
            border-bottom: 0;
        }

        .dropdown-content {
            width: 100%;
            display: block;
            min-width: 160px;
            z-index: 1;
            left: 0;
            top: 30px;
            background-color: #fff;
        }

        .dropdown-content li a {
            padding-left: 40px;
        }

        .dropdown-content-sub li a {
            padding-left: 60px;
        }


        /*.mobile-list>a {*/
        /*    background-color: #00b6cc;*/
        /*    color: #FFF;*/
        /*}*/
        /*.mobile-list {*/
        /*    background-image: url("http://staging-5-clinic.ru/wp-content/themes/medicenter/images/dropdown_plus.png");*/
        /*}*/

        /*.mobile-list {*/
        /*    position: absolute;*/
        /*    width: 38px;*/
        /*    height: 38px;*/
        /*    top: 0;*/
        /*    right: 0;*/
        /*    margin: 0;*/
        /*    padding: 0;*/
        /*    background: url("http://staging-5-clinic.ru/wp-content/themes/medicenter/images/accordion/accordion_plus.png") no-repeat center center;*/
        /*}*/

        .template-arrow-menu {
            position: absolute;
            width: 38px;
            height: 38px;
            top: 0;
            right: 0;
            margin: 0;
            padding: 10px 13px;

            img {
                width: 100%;
                transition: all 0.3s ease-in-out;
            }

            &.minus img {
                transform: rotateX(180deg);
            }
        }

    }
}

@media screen and (max-width: 480px) {
    .mobile-menu {
        &__collapse {
            width: 85%;
        }
    }
}
</style>
